module.exports = __webpack_public_path__ + "media/images/team_member/member_1-47e7cf61d2cbd85ea82f4a0b68192f5a.jpg";